const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230.65 32.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.31,22.61c4.45,1.2,8.91,2.4,14.45,3.89,1.14,2.21-.7,3.45-3.77,3.76-3.86.4-7.73.59-11.59.94-2.89.26-4.41-.95-4.2-3.87.21-3.05.55-6.1.95-9.13.17-1.27.86-2.48.95-3.75.56-7.87,2.5-10.35,10.39-11.52,3.99-.59,8.14-.36,12.2-.12.99.06,1.89,1.61,2.84,2.47-1,.79-1.95,2.18-3.02,2.28-4.03.38-8.12.15-12.15.51-3.77.33-5.14,2.75-4.41,6.83,2.65-.52,5.29-1.34,7.95-1.43,1.56-.05,3.16,1.07,4.74,1.66-1.25,1.02-2.35,2.53-3.78,2.96-3.66,1.09-7.46,1.7-11.2,2.5-.11.67-.23,1.35-.34,2.02Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.08,17.17c1.75,1.49,3.69,2.47,4.46,4.03.58,1.16-.36,3.06-.62,4.64-1.21-.52-2.54-.87-3.6-1.61-1.84-1.29-3.58-2.75-5.24-4.28-3.95-3.65-3.43-5.66,1.56-7.46,2.13-.77,4.05-2.11,6.52-3.44-5.63-3.25-10-1.51-12.6,5.07-1.63,4.12-1.83,8.78-3,13.11-.46,1.71-1.78,3.19-2.71,4.78-.87-1.69-2.69-3.54-2.44-5.03,1.03-6.02,2.23-12.09,4.25-17.82C38.82,3.08,49.01.14,54.55,3.39c3.64,2.13,4.13,6.67.86,9.92-1.47,1.46-3.38,2.47-5.34,3.86Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13,15.74c-1.45,4.96-2.57,9.47-4.15,13.82-.49,1.35-2.24,2.24-3.42,3.33-.55-1.59-1.76-3.29-1.53-4.76.77-4.92,1.64-9.9,3.27-14.58,1.28-3.67,3.52-7.07,5.78-10.29.71-1.01,2.93-1.62,4.28-1.4,3.01.49,6.22,1.12,8.74,2.68,1.88,1.17,3.72,3.8,3.89,5.91.15,1.86-1.6,4.58-3.31,5.73-4.25,2.84-8.95,3.31-13.56-.45ZM10.27,11.96c1.73.53,3.03,1.37,4.15,1.18,2.21-.39,4.33-1.34,6.48-2.07-1.64-1.18-3.21-2.48-4.96-3.48-.89-.52-2.09-.51-3.21-.75-.86,1.78-1.61,3.35-2.47,5.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59,10.78c2.9,2.37,4.98,3.9,6.86,5.65,3.28,3.06,3.04,6.14-.99,8.13-2.68,1.33-5.79,1.86-8.77,2.47-1.88.39-3.89.47-5.81.32-1.44-.11-2.84-.83-4.25-1.27,1.07-1.19,1.99-3.19,3.25-3.43,4.01-.77,8.15-.88,12.24-1.25.15-.5.31-1,.46-1.5-1.74-1.54-3.45-3.11-5.22-4.61-3.22-2.74-3.44-6.27.08-8.01,6.16-3.04,12.85-5.02,19.38-7.28.4-.14,1.93,1.28,1.82,1.68-.34,1.26-.93,2.98-1.92,3.42-2.49,1.1-5.28,1.52-7.9,2.36-2.75.89-5.45,1.95-9.23,3.32Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,21.24c.47.43.95.86,1.42,1.28,1.32,1.19,2.65,2.39,3.97,3.58.69-2.01,1.82-3.99,1.98-6.04.32-4.02.09-8.08.09-12.38-.55.03-2.18.38-3.72.15-1.28-.19-2.47-1.06-3.69-1.63.76-1.09,1.57-3.17,2.26-3.13,6.42.37,12.84,1.02,19.22,1.87.63.08,1.02,2.01,1.52,3.08-1.07.48-2.21,1.47-3.21,1.35-2.52-.3-4.99-1.1-6.98-1.59-.61,6.85-.85,13.36-1.99,19.7-.3,1.64-3.6,4.06-5.22,3.84-2.55-.34-5.29-2.22-7.06-4.22-.99-1.12-.18-3.81-.18-5.8.53-.02,1.06-.05,1.59-.07Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,26.79c-5.35.03-8.42-2.4-8.41-6.64.02-5.81,6.1-11.6,12.24-11.64,4.28-.03,10.3,5.44,10.42,9.46.15,5.05-5.87,8.77-14.25,8.81ZM79.73,17c-1.97.73-3.68,1.37-5.39,2.01-.5-1.53-1.01-3.06-1.88-5.71-1.86,2.57-3.44,4.73-5.3,7.3,8.52,2.09,12.02.88,12.57-3.59Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.14,7.13c-4.83-.21-9.66-.42-14.15-.62-2.16,7.53-2.27,15.56-8.94,21.01-1.17-7.42,3.14-13.69,3.93-21.58-3.27.78-6.27,1.68-9.34,2.13-1.1.16-3-.48-3.4-1.31-.46-.96-.02-2.75.66-3.74.51-.73,2.04-1.02,3.12-1.04,7.33-.15,14.67-.4,21.98-.1,2.24.09,4.42,1.83,6.63,2.81-.16.81-.33,1.62-.49,2.43Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,21.9c4.84-.63,9.59-1.33,14.36-1.82,1.22-.13,2.5.4,3.75.62-.65,1.31-1.18,3.66-1.98,3.75-6.08.74-12.22,1.32-18.32,1.2-1.1-.02-2.97-3.4-3.07-5.3-.43-8.12,8.15-16.76,17.8-17.54,1.21-.1,3.05,1.24,3.69,2.4.5.92,0,2.99-.8,3.82-.62.63-2.54.45-3.67.05-5.03-1.8-11.97,5.09-11.75,12.82Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.0000158aca377703137905a8d4df110f.svg";
export { ForwardRef as ReactComponent };